export class RaffleEntry {
  raffleId: string;
  raffleEntryNumber: string;
  entryDate: Date;
}
